import { ParentProps } from "solid-js"
import style from '../st-table.module.css'

export const Row = (props: ParentProps) => {
    return (
        <tr class={style['st-table-row']}>
            {props.children}
        </tr>
    )
}